unit GA.Web.Utils;

interface

uses WebLib.ExtCtrls;

type

TGAWebUtils = class
  class function RegulatorNumberValid(const ARegulator, ANumber: string): Boolean;
  class function EarliestClaimableDate(const ADate: TDate): TDate;
  class function EarliestClaimableDateStr(const ADate: TDate): string;
  class function EndofTaxYear(const ADate: TDate): TDate;
  class function StartOfTaxYear(const ADate: TDate): TDate;
end;

TDonationUIUtils = class
  const OTHER = 'Other';
  class procedure AddDonationClaimStatusLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddDonationKindLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddPaymentMethodLookupsToCombo(aComboItems: TLookupValues);
  class procedure AddAnalysisCodeLookupsToCombos(aCombo1, aCombo2: TLookupValues);
end;

implementation

uses System.SysUtils,
WebLib.RegularExpressions, System.DateUtils;

{ TGAWebUtils }

class function TGAWebUtils.RegulatorNumberValid(const ARegulator, ANumber: string): Boolean;
var lNumber: String;
begin
  lNumber := ANumber.Trim;
  Result := lNumber <> '';

  if not Result then
     Exit;

  { TODO : Check that the CharityId is a valid format TRegEx. }
end;


class function TGAWebUtils.EarliestClaimableDate(const ADate: TDate): TDate;
var
  lTaxYearEnd: TDate;
begin
  lTaxYearEnd := EndofTaxYear(ADate);
  Result := StartOfTaxYear(IncYear(lTaxYearEnd, -4));
end;

class function TGAWebUtils.EarliestClaimableDateStr(const ADate: TDate): string;
var
  lEarliestDate: TDate;
begin
  lEarliestDate := EarliestClaimableDate(ADate);
  result := FormatDateTime('DD/MM/YYYY', lEarliestDate);
end;

class function TGAWebUtils.EndofTaxYear(const ADate: TDate): TDate;
var
  lYear, lMonth, lDay: Word;
begin
  DecodeDate(ADate, lYear, lMonth, lDay);

  if (lMonth = 4) then
  begin
    if lDay > 5 then
      lYear := lYear + 1
  end
  else if lMonth > 4 then
  begin
    lYear := lYear + 1;
  end;

  Result := EncodeDate(lYear, 4, 5);
end;

class function TGAWebUtils.StartOfTaxYear(const ADate: TDate): TDate;
var
  lYear, lMonth, lDay: Word;
begin
  DecodeDate(ADate, lYear, lMonth, lDay);

  if (lMonth = 4) then
  begin
    if lDay < 6 then
      lYear := lYear - 1
  end
  else if lMonth < 4 then
  begin
    lYear := lYear - 1;
  end;

  Result := EncodeDate(lYear, 4, 6);
end;

{TDonationUIUtils}

class procedure TDonationUIUtils.AddAnalysisCodeLookupsToCombos(aCombo1, aCombo2: TLookupValues);
begin
  aCombo1.Clear;
  aCombo1.AddPair('AnalysisCode1', 'AnalysisCode 1');
  aCombo1.AddPair('AnalysisCode2', 'AnalysisCode 2');

  aCombo2.Clear;
  aCombo2.AddPair('AnalysisCode3', 'AnalysisCode 3');
  aCombo2.AddPair('AnalysisCode4', 'AnalysisCode 4');
end;

class procedure TDonationUIUtils.AddDonationClaimStatusLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair('Unclaimed', 'Unclaimed');
  aComboItems.AddPair('NonGiftAidable', 'Non-Gift Aidable');
  aComboItems.AddPair('NGACustomerRequest', 'Non-Gift Aidable by Customer Request');
  aComboItems.AddPair('ForeignDonation', 'Foreign Donation');
  aComboItems.AddPair('Unknown', 'Unknown');
end;

class procedure TDonationUIUtils.AddDonationKindLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair('Donation', 'Donation');
  aComboItems.AddPair('GiveAsYouEarn', 'Give As You Earn');
  aComboItems.AddPair('PayrollGiving', 'Payroll Giving');
  aComboItems.AddPair('PayrollGovernmentScheme', 'Payroll Government Scheme');
  aComboItems.AddPair('Legacy', 'Legacy');
  aComboItems.AddPair(OTHER, OTHER);
end;

class procedure TDonationUIUtils.AddPaymentMethodLookupsToCombo(aComboItems: TLookupValues);
begin
  aComboItems.Clear;
  aComboItems.AddPair('Cash', 'Cash');
  aComboItems.AddPair('Card', 'Card');
  aComboItems.AddPair('Cheque', 'Cheque');
  aComboItems.AddPair('StandingOrder', 'Standing Order');
  aComboItems.AddPair('DDR', 'DDR');
  aComboItems.AddPair('BankTransfer', 'Bank Transfer');
  aComboItems.AddPair('PayPal', 'PayPal');
  aComboItems.AddPair('WebCard', 'Web Card');
  aComboItems.AddPair(OTHER, OTHER);
end;

end.
